import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment';
import _ from 'lodash';

import MaterialTable from 'material-table';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';

import { Edit, Delete } from '@material-ui/icons';
import { RenderIconButton } from '../../Channel/shared/components/GenericComponents';

const styles = theme => ({});

const tableSize = {
  cellStyle: { padding: '4px 15px 4px 15px' },
  headerStyle: { padding: '4px 15px 4px 15px' },
};

export class GameTable extends Component {
  isAManualGame(game) {
    return game.id.indexOf('manual_') !== -1;
  }

  orderTeams = () => {
    const { leagueSelected } = this.props;
    let homeposition = {
      right: 'away',
      left: 'home',
    };

    if (leagueSelected && leagueSelected.homePosition) {
      const position = leagueSelected.homePosition;
      switch (position) {
        case 'left':
          homeposition = { right: 'away', left: 'home' };
          break;
        case 'right':
          homeposition = { right: 'home', left: 'away' };
          break;
        default:
          homeposition = { right: 'away', left: 'home' };
          break;
      }
    }
    return homeposition;
  };

  renderGame(gameRow, position) {
    const { classes } = this.props;

    const leftLogo = _.get(gameRow, `${position.left}Logo.url`, '');
    const rightLogo = _.get(gameRow, `${position.right}Logo.url`, '');
    return (
      <div className="game-row">
        <div className="team-left">
          <div className="team-name">{gameRow[`${position.left}`]}</div>
          <div className="team-left-logo">
            <Card className={classes.card}>
              <CardMedia
                style={{
                  backgroundImage: `url(${leftLogo})`,
                  backgroundSize: 'contain',
                  padding: '0px',
                  border: '1px solid rgba(255, 255, 255, 1)',
                  width: '50px',
                  height: '50px',
                }}
                image={`url('${leftLogo}')`}
              />
            </Card>
          </div>
        </div>
        <div className="game-Score">
          <span className="score">{`${this.showScore(
            gameRow[`${position.left}Score`]
          )}    - ${this.showScore(gameRow[`${position.right}Score`])}`}</span>
        </div>
        <div className="team-right">
          <div className="team-right-logo">
            <Card className={classes.card}>
              <CardMedia
                style={{
                  backgroundImage: `url(${rightLogo})`,
                  backgroundSize: 'contain',
                  padding: '0px',
                  border: '1px solid rgba(255, 255, 255, 1)',
                  width: '50px',
                  height: '50px',
                }}
                image={`url('${rightLogo}')`}
              />
            </Card>
          </div>
          <div className="team-name">{gameRow[`${position.right}`]}</div>
        </div>
      </div>
    );
  }

  showScore = score => {
    return score ? score : 0;
  };

  render() {
    const {
      confirmDeleteGame,
      games,
      daySelected,
      fillDialogForm,
      changeDialogState,
      updateCalendarEvents,
      targetMonth,
      getDailyEvents,
    } = this.props;
    return (
      <MaterialTable
        elevation={0}
        xs={12}
        options={{
          pageSizeOptions: [5, 10, 20],
          pageSize: 10,
          toolbar: true,
          paging: true,
          emptyRowsWhenPaging: false,
          search: true,
        }}
        columns={[
          {
            ...tableSize,
            title: 'Game',
            field: 'scheduled',
            render: rowData => {
              const position = this.orderTeams();
              return this.renderGame(rowData, position);
            },
            sorting: false,
          },
          {
            ...tableSize,
            title: 'Starting Hour',
            field: 'scheduled',
            defaultSort: 'asc',
            render: rowData => {
              return (
                <div className="just-bold">{moment(rowData.scheduled).format('LT')}</div>
              );
            },
            type: 'date',
          },
          {
            ...tableSize,
            title: 'Game Status',
            field: 'status',
            customSort: (a, b) =>
              a.status.toLowerCase().localeCompare(b.status.toLowerCase()),
          },
          {
            ...tableSize,
            title: 'Options',
            render: rowData => (
              <div>
                <React.Fragment>
                  <RenderIconButton
                    disabled={rowData.hasDependencies}
                    clickEvent={() => {
                      confirmDeleteGame(rowData, this.orderTeams(), daySelected);
                    }}
                    title={'Delete Game'}
                    placement={'top'}
                    icon={<Delete />}
                    color={'primary'}
                  />

                  <RenderIconButton
                    clickEvent={() => {
                      changeDialogState(true);
                      fillDialogForm(rowData);
                    }}
                    title={'Edit Game'}
                    placement={'top'}
                    icon={<Edit />}
                    color={'primary'}
                  />
                </React.Fragment>
              </div>
            ),
            sorting: false,
          },
        ]}
        data={games}
        title={'Games'}
        actions={[
          {
            icon: 'refresh',
            tooltip: 'Refresh Data',
            isFreeAction: true,
            onClick: () => {
              updateCalendarEvents(targetMonth);
              getDailyEvents(daySelected);
            },
          },
        ]}
      />
    );
  }
}

export default withStyles(styles)(GameTable);
